import { useEffect, useState } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

type DummyImages = typeof import('@/features/messages/dummyImagesBase64');

const imageKeys = {
  'editor-dummy-product-1': 'ProductVaseImage1',
  'editor-dummy-product-2': 'ProductVaseImage2',
} as const;

const isDummyImage = (image: string): image is keyof typeof imageKeys =>
  Object.prototype.hasOwnProperty.call(imageKeys, image);

export const useEditorProductImages = (images?: string[]) => {
  const { isEditor } = useEnvironment();
  const [dummyImages, setDummyImages] = useState<DummyImages>();
  const needsImages = Boolean(images?.some(isDummyImage));

  useEffect(() => {
    if (!isEditor || !needsImages) {
      return;
    }

    let cancelled = false;
    import('@/features/messages/dummyImagesBase64')
      .then((module) => {
        if (!cancelled) {
          setDummyImages(module);
        }
      })
      .catch(() => {
        // Preview content remains usable without these optional images.
      });

    return () => {
      cancelled = true;
    };
  }, [isEditor, needsImages]);

  return images?.flatMap((image) => {
    if (!isDummyImage(image)) {
      return [image];
    }
    const source = isEditor && dummyImages?.[imageKeys[image]];
    return source ? [source] : [];
  });
};
